import { FormEvent } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { SetState } from "zustand";
import { ICriminalCPFstore } from "..";
import { IConsultaCriminal } from "../../../interface/criminal";

export interface ICriminalCPFModuleStore {
  resultadoCriminalCPF: IConsultaCriminal[] | null;
  mensagemCriminalCPF?: string;
  consultaCriminalCPF(url: string, cpf: string, e?: FormEvent): Promise<void>;
  limparConsultaCriminalCPF(): void;
}

export default (set: SetState<ICriminalCPFstore>) =>
  ({
    resultadoCriminalCPF: null,
    async consultaCriminalCPF(url, cpf, e) {
      e?.preventDefault();
      try {
        const storedToken = sessionStorage.getItem("@webSDS:token");

        set((state) => ({
          ...state,
          global: {
            ...state.global,
            loading: true,
          },
        }));

        if (cpf === "") {
          toast.error("Preencha o campo!", {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 4000,
          });
        } else {
          const response = await axios.get(
            `${url}/wsCriminal/BuscarCidadaoPorCPF/${cpf}`,
            {
              headers: {
                Authorization: `Bearer ${storedToken}`,
              },
            }
          );

          if (response.status === 200) {
            set((state) => ({
              ...state,
              global: {
                ...state.global,
                loading: false,
              },
              criminal: {
                ...state.criminal,
                resultadoCriminalCPF: response.data,
              },
            }));
          }
          if (response.status === 400) {
            toast.error(`${response.data}`, {
              position: toast.POSITION.TOP_CENTER,
              autoClose: 4000,
            });
          }
          if (response.status === 401) {
            toast.error(
              "A SUA SESSÃO EXPIROU, EFETUE LOGIN NOVAMENTE PARA CONTINUAR USANDO O POLÍCIA ÁGIL.",
              {
                position: toast.POSITION.TOP_CENTER,
                autoClose: 4000,
              }
            );
            // logout()
          }
          if (response.status === 404) {
            // toast.error(`${response.data}`, {
            //   position: toast.POSITION.TOP_CENTER,
            //   autoClose: 4000,
            // })
            set((state) => ({
              criminal: {
                ...state.criminal,
                resultadoCriminalCPF: null,
                mensagemCriminalCPF: response.data,
              },
            }));
          }
          if (response.status === 500 || response.status === 503) {
            toast.error("ERRO NO SERVIDOR, TENTE MAIS TARDE!", {
              position: toast.POSITION.TOP_CENTER,
              autoClose: 4000,
            });
            return;
          }
          if (response.status === 504) {
            toast.error(
              "O SERVIDOR DEMOROU MUITO PARA RESPONDER, TENTE NOVAMENTE EM INSTANTES.",
              {
                position: toast.POSITION.TOP_CENTER,
                autoClose: 4000,
              }
            );
            return;
          }
        }
      } catch (error) {
        toast.error("ERRO DE CONEXÃO! VERIFIQUE SUA INTERNET!", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 4000,
        });
      } finally {
        set((state) => ({
          ...state,
          global: {
            ...state.global,
            loading: false,
          },
        }));
      }
    },
    limparConsultaCriminalCPF() {
      set((state) => ({
        ...state,
        criminal: {
          ...state.criminal,
          resultadoCriminalCPF: null,
          mensagemCriminalCPF: undefined,
        },
      }));
    },
  } as ICriminalCPFModuleStore);
